import { render, staticRenderFns } from "./reg_multi_select_question.vue?vue&type=template&id=7ca236de&"
import script from "./reg_multi_select_question.vue?vue&type=script&lang=js&"
export * from "./reg_multi_select_question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports